export enum PackageProductSubtype {
  Premium = 1,
  VideoUpsale = 2,
  Vip = 3,
  Boost = 4,
  Sticker = 5,
  // PinToTop = 7,
  Credit = 8,
  CreditUpsale = 9,
}
